import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import * as Styles from './styles'

const ParcelEta = ({ date, withDivider }) => {
  const theme = useTheme()
  const { info } = useContext(AppContext)
  const { t, i18n } = useTranslation()

  if (!date) return null

  return (
    <Styles.Container>
      <Text type="bodyMRegular" color={theme.colors.text.subtle}>
        {t('Entrega estimada')}:
      </Text>
      <Text type="bodyMRegular">
        {new Intl.DateTimeFormat(i18n.language, {
          weekday: 'long',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          timeZone: info?.selectedStore?.timezone,
        }).format(new Date(date))}
        {withDivider && ' | '}
      </Text>
    </Styles.Container>
  )
}

export default ParcelEta
